export default __webpack_public_path__ + "static/media/la-yogi.1eee6cc6.jpg";